// AddRole — modal-embedded form for creating a Role row.
// Refactored 2026-05-05 (Phase 3.1, Class P) onto ModalFormHeader.

import { useEffect, useState } from 'react';
import CTextField from '../CTextField/CTextField';
import { Button, Stack, Box, Typography } from '@mui/material';
import { AdminPanelSettingsOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import CMultiSelect from '../CMutiSelect/CMultiSelect';
import { getPermission } from '../../feature/permissionsSlice';
import { createRole } from '../../feature/roleSlice';
import { toast } from 'react-toastify';
import CSwitch from '../CSwitch/CSwitch';
import { ModalFormHeader, FieldLabel } from '../PaperForm';

const AddRole = (props) => {
  const dispatch = useDispatch();
  const [roleName, setRoleName] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [notificationEnabled, setNotificationEnabled] = useState(false);

  const { permissions } = useSelector((state) => state.permissionSlice);
  const handleChange = (event) => {
    setRoleName(event.target.value);
  };

  const handleSubmit = () => {
    if (roleName === '') return toast('Please enter a Role name.');
    const data = {
      name: roleName,
      permissions: selectedPermissions,
      isNotification: notificationEnabled,
    };
    dispatch(createRole(data)).then((res) => {
      if (res.type === 'createRole/roles/fulfilled') {
        toast('Role created successfully!');
        props.setOpen(false);
      }
    });
  };

  useEffect(() => {
    if (permissions.length === 0) {
      dispatch(getPermission());
    }
  }, [dispatch, permissions.length]);

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Role"
        title="Add Role"
        icon={AdminPanelSettingsOutlined}
      />
      <Stack spacing={2}>
        <CTextField onChange={handleChange} name="name" label="Role name" required />
        <Box>
          <FieldLabel hint="optional · select all that apply">Permissions</FieldLabel>
          <CMultiSelect
            data={permissions}
            permission={selectedPermissions}
            selectedPermissions={setSelectedPermissions}
          />
        </Box>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Notifications
          </Typography>
          <CSwitch
            active={notificationEnabled}
            name="orderArrivedInFull"
            setSwitch={() => setNotificationEnabled(!notificationEnabled)}
          />
        </Stack>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: '100%',
            mt: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: '0.01em',
          }}
        >
          Create Role
        </Button>
      </Stack>
    </Box>
  );
};

export default AddRole;
